/**
 * Converts a weekday into a query that includes all shifts for that day
 */
export function weekdaysToQuery(selectedWeekdays: number[]) {
	const out: string[] = [];

	// Mon
	if (selectedWeekdays.includes(0)) {
		out.push("monday");
	}
	// Tue
	if (selectedWeekdays.includes(1)) {
		out.push("tuesday");
	}
	// Wed
	if (selectedWeekdays.includes(2)) {
		out.push("wednesday");
	}
	// Thu
	if (selectedWeekdays.includes(3)) {
		out.push("thursday");
	}
	// Fri
	if (selectedWeekdays.includes(4)) {
		out.push("friday");
	}
	// Sat
	if (selectedWeekdays.includes(5)) {
		out.push("saturday");
	}
	// Sun
	if (selectedWeekdays.includes(6)) {
		out.push("sunday");
	}

	return out.join(",");
}
